module.exports = __webpack_public_path__ + "static/media/gg.f4456689.svg";